export const FILTER_FIELDS = [
  {
    label: "UTM Source",
    key: "utm_source",
  },
  {
    label: "UTM Medium",
    key: "utm_medium",
  },
  {
    label: "UTM Campaign",
    key: "utm_campaign",
  },
  {
    label: "UTM Content",
    key: "utm_content",
  },
  {
    label: "UTM Term",
    key: "utm_term",
  },
];

export const getStartingColumnFiltersText = () => {
  return FILTER_FIELDS.reduce((prev, column) => ({ ...prev, [column.key]: "" }), {});
};
